<script setup lang="ts">
import api from "@/api";
// import { useCaptchaComposable } from "@/components/shared/recaptcha/recaptcha";
import { useToastStore } from "@/store/toast";
import type { ComponentPublicInstance } from "vue";
import { validatePassword } from "@/assets/js/helpers";

definePage({
	name: "auth.reset-password",
});

const emit = defineEmits(["click-back"]);
// const { recaptcha } = useCaptchaComposable();
const toastStore = useToastStore();
const route = useRoute();
// const router = useRouter();

const form = reactive({ password: "", confirmPassword: "" });
const resetPassInputRef = ref<ComponentPublicInstance | null>(null);
// const passwordRules = CValidate.passwordRAllCombo(8);
const isValidPassword = computed(() => validatePassword(form.password));

const isLoading = ref(false);
const buttonDisabled = computed(
	() =>
		!form.password ||
		!isValidPassword.value ||
		form.password !== form.confirmPassword,
);

const isSuccess = ref(false);
async function clickResetPass() {
	// const google_token = await recaptcha("resetPass");
	const google_token = "";
	const params = {
		token: route.query.token as string,
		password: form.password,
		google_token,
	};
	try {
		const res = await api.authResetPass(params);
		toastStore.openToastSuccess(res.data.message);
		// router.push({
		// 	name: "auth.login",
		// });
		isSuccess.value = true;
	} catch (err: any) {
		toastStore.openToastError(err.response?.data?.message || err.message);
		console.error(err.message);
	}
}

onMounted(() => {
	setTimeout(() => {
		resetPassInputRef.value?.$el.querySelector("input")?.focus();
	}, 400);
});
</script>

<template>
	<div class="reset-pass">
		<div class="image-section">
			<img
				alt="placeholder-image"
				src="@/assets/image/nice-lady.png"
			/>
		</div>
		<p-card>
			<template #content>
				<template v-if="!isSuccess">
					<p-fluid
						class="flex w-full flex-col max-w-500px justify-between gap-7"
					>
						<div>
							<p-float-label>
								<p-password
									id="auth-password"
									v-model="form.password"
									type="password"
									:invalid="!!form.password && !isValidPassword"
									toggle-mask
									:feedback="false"
								></p-password>
								<label for="auth-password">{{ $t("app.auth.pass") }}</label>
							</p-float-label>
							<small
								:class="{
									invalid: !!form.password && !isValidPassword,
									valid: form.password && isValidPassword,
								}"
							>
								{{ $t("app.auth.passRules") }}
							</small>
						</div>
						<div>
							<p-float-label>
								<p-password
									id="auth-password"
									v-model="form.confirmPassword"
									type="password"
									:invalid="!!form.password && !isValidPassword"
									toggle-mask
									:feedback="false"
								></p-password>
								<label for="auth-password">
									{{ $t("app.auth.confirmPass") }}
								</label>
							</p-float-label>
							<small
								:class="{
									invalid:
										form.confirmPassword &&
										form.confirmPassword !== form.password,
									valid:
										form.confirmPassword &&
										form.confirmPassword === form.password,
								}"
							>
								{{ $t("app.auth.confirmPassText") }}
							</small>
						</div>
						<p-button
							:disabled="isLoading || buttonDisabled"
							@click="clickResetPass"
						>
							{{ $t("app.auth.reset") }}
						</p-button>
					</p-fluid>
				</template>
				<template v-else>
					<p-fluid
						class="flex w-full flex-col max-w-500px justify-between gap-7"
					>
						<p>{{ $t("app.auth.resetSuccessText") }}</p>
						<p-button
							class="mt-4"
							as="router-link"
							:to="{ name: 'auth.login' }"
						>
							<span>{{ $t("app.auth.returnLogin") }}</span>
						</p-button>
					</p-fluid>
				</template>
			</template>
		</p-card>
	</div>
</template>

<style lang="scss" scoped>
.reset-pass {
	align-items: center;
	max-width: 500px;
	display: flex;
	// flex-direction: column;
	justify-content: center;
	flex-wrap: wrap;
	gap: 40px 170px;
	// height: 100%;
	min-height: calc(100vh - 100px);
	width: 100%;

	.image-section,
	.comp-section {
		display: flex;
		min-width: 300px;
		align-items: center;
		justify-content: center;
	}
	.invalid {
		color: var(--p-red-600);
	}
	.valid {
		color: var(--p-green-600);
	}
	.form {
		display: flex;
		flex-direction: column;
		gap: 30px;
		max-width: 350px;
		width: 350px;
		padding: 0 20px 20px;
	}
}
</style>
